export const fixTo3DecimalPlaces = (value: number): number => +value.toFixed(3);

export const floorTo3DecimalPlaces = (value: number): number =>
  fixTo3DecimalPlaces(Math.floor(fixTo3DecimalPlaces(value * 1000)) / 1000);
